import { createSelector } from "@ngrx/store";

import { JobDetailsV2Fragment } from "../../generated/graphql.generated";
import { quickAccessFeature } from "../base/menu/quick-access/quick-access-reducers";
import { navigatorOutboxFeature } from "../job/job-navigator/navigator-outbox/navigator-outbox.reducer";


import { jobsFeature } from "../jobs/jobs.reducer";

import { ActionSource } from "./action-sources";
import { PersistedState } from "./persist-state.utils";
import { compactUnsavedChanges } from "./unsaved-changes-compaction";
import { unsavedChangesFeature } from "./unsaved-changes.reducer";

export const selectPersistedState = createSelector(
  jobsFeature.selectJobs,
  unsavedChangesFeature.selectQueue,
  quickAccessFeature["selectQuick AccessState"],
  navigatorOutboxFeature.selectQueue,
  (allJobs, allChanges, { pinnedJobs, recentJobs, lastOpenedJobPageByJobId }, navigatorOutbox): PersistedState => {

    const jobIds = [
      ...pinnedJobs,
      ...recentJobs,
    ];

    const jobs = Object.fromEntries(Object.entries(allJobs)
      .filter(([ jobId ]) => jobIds.includes(jobId))) as { [ jobId: string ]: JobDetailsV2Fragment };

    const queue = compactUnsavedChanges(allChanges.filter(
      (c) => jobIds.includes(c.jobId) || c.source === ActionSource.NEW_OPPORTUNITY || c.source === ActionSource.NEW_OPPORTUNITY_V4,
    ));

    const filteredLastOpenedJobPageByJobId = Object.fromEntries(
      Object.entries(lastOpenedJobPageByJobId)
      .filter(([ jobId ]) => jobIds.includes(jobId)),
    ) as PersistedState['lastOpenedJobPageByJobId'];

    return {
      pinnedJobs,
      recentJobs,
      lastOpenedJobPageByJobId: filteredLastOpenedJobPageByJobId,
      jobs,
      queue,
      navigatorOutbox,
    };
  }
);
